<app-settings-alvolo-activate *ngIf="!next" (eventEmitterNextStep)="eventEmitterNextStepHandler($event)"></app-settings-alvolo-activate>
<app-settings-alvolo-create-shop *ngIf="next"></app-settings-alvolo-create-shop>